import * as React from "react"
import { useEffect } from "react";
import { batch } from "@preact/signals-react";
import { Box } from "@mui/material"

import { CommonFilters } from "@components";
import {COMMON_FILTER_KEYS, SHARE_OF_SEARCH_ROUTES} from "@constants";
import { useAppDefaultFilters } from "@hooks";
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import {shareOfSearchStatusIsEmpty} from "./@signals";



export default function ShareOfSearchStatusFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(SHARE_OF_SEARCH_ROUTES.STATUS_ID, SHARE_OF_SEARCH_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="sos-status-filters">
    <CommonFilters
        components={{
            country: true, site: true, keyword: true
        }}
        compProps={{
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.KEYWORD],
                dashboardKey: SHARE_OF_SEARCH_ROUTES.STATUS_ID
            },
            site: { grid: { xs: 12, md: 4 } },
            country: { grid: { xs: 12, md: 4 } },
            keyword: { grid: { xs: 12, md: 4 } },
            actions: { grid: { xs: 12, md: 12 } }
        }}
        onSubmit={() => batch(() => {
            isLoadingCommonFilters.value = true
            shareOfSearchStatusIsEmpty.value = false
            isSystemBusy.value = false
        })}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}